import { GeoJsonLayer } from "@deck.gl/layers";
import { easeOutBack } from "lib/helpers/math";
import mapData from "lib/stores/mapData";
import context from "lib/stores/context";
import geojson from "lib/data/.geo.json";

let memoizedLineWidthInput;
let memoizedLineColorValue;
let memoizedLineColorInput;

geojson.features = geojson.features.filter(d => d.geometry);

const getLineColor = (info, object) => {
  const { activeCountry } = context;
  if (memoizedLineColorInput === activeCountry) {
    return memoizedLineColorValue;
  }
  memoizedLineColorInput === activeCountry;
  if (!activeCountry) return [25, 25, 25];
  if (info.properties.ISO_A3 === activeCountry) {
    switch (mapData.activeCategory) {
      case "prevalence":
        memoizedLineColorValue = [126, 178, 226];
        return memoizedLineColorValue;
      case "vulnerability":
        memoizedLineColorValue = [102, 171, 171];
        return memoizedLineColorValue;
      case "gov-response":
        memoizedLineColorValue = [255, 133, 115];
        return memoizedLineColorValue;
      default:
        memoizedLineColorValue = [255, 204, 43];
        return memoizedLineColorValue;
    }
  }
  return [25, 25, 25];
};

const getLineWidth = (info, object) => {
  const { activeCountry } = context;
  if (!activeCountry) return 0;
  if (info.properties.ISO_A3 === activeCountry) {
    return 4;
  }
  return 0;
};

const setSelectedCountryLayer = () => {
  return new GeoJsonLayer({
    id: "country-select-lines",
    data: geojson,
    filled: false,
    lineWidthMinPixels: 0,
    lineWidthMaxPixels: 4,
    opacity: 1,
    lineWidthUnits: "pixels",
    getLineColor: getLineColor,
    getLineWidth: getLineWidth,
    getPolygon: d => d.polygon,
    updateTriggers: {
      getElevation: [context.activeCountry]
    },
    transitions: {
      getLineWidth: {
        duration: 1000,
        easing: easeOutBack
      },
      getLineColor: {
        duration: 1000,
        easing: easeOutBack
      }
    }
  });
};

export { setSelectedCountryLayer };
